import './ChapterPage.scss';
import Component from './ChapterPage.js';
export default Component;
